import SubHeading from './SubHeading'

export default SubHeading
